import { render } from "./SliderNewsAside.vue?vue&type=template&id=591f351f&ts=true&lang=pug"
import script from "./SliderNewsAside.vue?vue&type=script&setup=true&lang=ts"
export * from "./SliderNewsAside.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__